import { jsx, Fragment } from 'react/jsx-runtime';
import { IconButton, Persona, PersonaSize } from '@fluentui/react';
import Tooltip from '../../../../Tooltip/Tooltip.esm.js';
import LoginButtons from '../LoginButtons/LoginButtons.esm.js';
import LoadingUserButton from './LoadingUserButton/LoadingUserButton.esm.js';
import { sharedClassNames } from '../../styles.esm.js';
import { useContext, useCallback } from 'react';
import UserContext from '../../../../context/userContext.esm.js';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../../context/context.esm.js';
import logger from '@agoras/logger';
import { headerContext } from '../../../context.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var UserButtons = function() {
    var _useContext = useContext(AppContext), _useContext_user = _useContext.user, loading = _useContext_user.loading, signedIn = _useContext_user.signedIn;
    var profileImageUrl = useContext(UserContext).profileImageUrl;
    var setOpenPanelKey = useContext(AppContext).setOpenPanelKey;
    var t = useTranslation('header').t;
    var userButtonTooltip = t('My account');
    var handleOpenUserPanel = useCallback(function() {
        logger.info(JSON.stringify({
            key: 'user'
        }), _object_spread({
            action: 'Navbar',
            actionModifier: 'Click'
        }, headerContext));
        setOpenPanelKey === null || setOpenPanelKey === void 0 ? void 0 : setOpenPanelKey('user');
    }, [
        setOpenPanelKey
    ]);
    if (loading) {
        return /*#__PURE__*/ jsx(LoadingUserButton, {});
    }
    return signedIn ? /*#__PURE__*/ jsx(Fragment, {
        children: /*#__PURE__*/ jsx(Tooltip, {
            tooltipHostProps: {
                content: userButtonTooltip,
                styles: {
                    root: {
                        height: '100%'
                    }
                }
            },
            children: /*#__PURE__*/ jsx(IconButton, {
                className: sharedClassNames.iconButton,
                onClick: handleOpenUserPanel,
                ariaLabel: userButtonTooltip,
                children: /*#__PURE__*/ jsx(Persona, {
                    size: PersonaSize.size32,
                    hidePersonaDetails: true,
                    imageAlt: userButtonTooltip,
                    imageUrl: profileImageUrl
                })
            })
        })
    }) : /*#__PURE__*/ jsx(LoginButtons, {});
};

export { UserButtons as default };
